export enum DocumentType {
  RG = 'RG',
  RNE = 'RNE',
  CNH = 'CNH',
}
